import { render, staticRenderFns } from "./WidgetReports.vue?vue&type=template&id=a045614a&scoped=true&"
import script from "./WidgetReports.vue?vue&type=script&lang=js&"
export * from "./WidgetReports.vue?vue&type=script&lang=js&"
import style0 from "./WidgetReports.vue?vue&type=style&index=0&id=a045614a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045614a",
  null
  
)

export default component.exports